module.exports = __webpack_public_path__ + "static/corn-23bdf800b8564648821eb051c2872324.jpg";